.cover-holder {
  position: absolute;
  top: 0;
  height: 100%;
  width: 100%;
  padding: 0.4rem;
  border-radius: 0.6rem;
  overflow: hidden;
}

.image {
  height: 100%;
  width: 100%;
  object-fit: cover;
  box-shadow: none;
  cursor: pointer;
  border-radius: 0.6rem;
}

.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.65);
  display: flex;
  justify-content: center;
  align-items: center;
  color: lightgray;
  font-size: 2.4rem;
  opacity: 0;
  transition: all 0.2s ease-in-out;
  border-radius: 0.6rem;
  z-index: 1;

  &[data-show='true'] {
    opacity: 1;
  }
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.8rem;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  z-index: 10;
  opacity: 0;

  & svg {
    color: #cacdd5;
  }

  & span {
    color: #cacdd5;
    font-size: 1.4rem;
    line-height: 2rem;
    font-weight: 400;
  }

  &[data-show='true'] {
    opacity: 1;
  }
}
